import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=27fc8998&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
import style0 from "./Login.vue?vue&type=style&index=0&id=27fc8998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc8998",
  null
  
)

export default component.exports